import React, { useEffect, useState } from 'react';
import { FREE_PACKAGE_CODES } from '@src/constants/package';
import { useSelector } from 'react-redux';
import { CODES } from '@src/constants/tasks';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import useWindowDimensions from '@src/hooks/useWindowDimensions';
import { Skeleton } from '@mui/material';
import CommonButton from '@src/new-components/Button';
import apis from '@src/apis';
import Typography from '@src/new-components/Typography';
import { COLOR } from '@src/styles/color';
import logo from '@src/assets/logo/logo-AiVoice-new.svg';
import { StyledTaskList, StyledTasks, StyledTasksHeader } from './index.styled';
import Task from './Task';

const Tasks = ({ showHeader, onClose, preventScroll, fromPopup }) => {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(false);
  const { height } = useWindowDimensions();
  const { taskCompletedData } = useSelector((state) => state.layout);
  const { user } = useSelector((state) => state.auth);
  const isFreeUser = FREE_PACKAGE_CODES.includes(user?.packageCode);
  const { t } = useTranslation();

  useEffect(() => {
    const getTasks = async () => {
      setLoading(true);
      const response = await apis.tasks.getTasks('ONBOARDING');
      setTasks(response || []);
      setLoading(false);
    };

    getTasks();
  }, [taskCompletedData]);

  return (
    <StyledTasks fromPopup={fromPopup}>
      <div className="container-tasks">
        {showHeader && (
          <>
            <StyledTasksHeader preventScroll={preventScroll}>
              <img src={logo} alt="logo" />
              <CommonButton
                onClick={onClose}
                variant="outlineSmall"
                customStyle={{
                  padding: '8px 24px',
                  height: '40px',
                  borderRadius: '8px',
                }}
                textProps={{
                  variantText: 'body-14-semibold',
                  color: COLOR.darkBlue,
                }}
              >
                {t('later')}
              </CommonButton>
            </StyledTasksHeader>
            <Typography
              style={{
                marginBottom: '24px',
              }}
              className="title-onboarding"
              variant="heading-32-bold"
              color={COLOR.descriptionGray}
              dangerouslySetInnerHTML={{ __html: t('titleOnboardingTasks') }}
            />
          </>
        )}

        <StyledTaskList
          height={height}
          className={!preventScroll ? 'small-scrollbar' : 'hidden-scrollbar'}
          preventScroll={preventScroll}
        >
          {loading
            ? Array.from({ length: 10 }).map(() => (
                <Skeleton
                  variant="rectangular"
                  width="100%"
                  height={80}
                  style={{ borderRadius: '8px' }}
                />
              ))
            : tasks
                ?.filter(
                  (task) =>
                    (task.code !== CODES.DAILY_LOGIN || isFreeUser) &&
                    (!task.expiresAt ||
                      moment(task.expiresAt).isAfter(moment())),
                )
                .map((task) => (
                  <Task key={task.id} task={task} onClose={onClose} />
                ))}
        </StyledTaskList>
      </div>
    </StyledTasks>
  );
};

export default Tasks;
